/**
 * Project Ongoing Progress Tracker %
 *
 * - Only Effort Expenses: completed tasks share 90%; project submit → 100%
 * - Only Other Expenses: completed tasks share 90%; project submit → 100%
 * - Both Effort + Other: keep 90% Effort / 10% Other ratio
 * - When project is submitted (isProjectComplete): always 100%
 */
export function calculateProjectOngoingProgress({
  workEntries = [],
  descriptionEntries = [],
  isProjectComplete = false,
} = {}) {
  if (isProjectComplete) return 100;

  const workList = Array.isArray(workEntries) ? workEntries : [];
  const descList = Array.isArray(descriptionEntries) ? descriptionEntries : [];

  const workTotal = workList.length;
  const descTotal = descList.length;
  const workCompleted = workList.filter((entry) => entry?.isTaskComplete).length;
  const descCompleted = descList.filter((entry) => entry?.isTaskComplete).length;

  const hasWork = workTotal > 0;
  const hasDesc = descTotal > 0;

  if (!hasWork && !hasDesc) return 0;

  // Both present → existing 90 : 10 ratio
  if (hasWork && hasDesc) {
    const workProgress = (workCompleted / workTotal) * 90;
    const descriptionProgress = (descCompleted / descTotal) * 10;
    return workProgress + descriptionProgress;
  }

  // Only one expense type → tasks fill up to 90%; submit fills the rest to 100%
  if (hasWork) {
    return (workCompleted / workTotal) * 90;
  }

  return (descCompleted / descTotal) * 90;
}
